// extracted by mini-css-extract-plugin
module.exports = {"avatarImg":"register_avatarImg_3Hx0m","clearButtonContainer":"register_clearButtonContainer_1MeVg"};